import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full grid lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-neutral-900" }
const _hoisted_2 = { class: "lg:sticky lg:top-0 lg:left-0 w-full lg:h-screen p-8 pt-32 lg:py-32 flex flex-col bg-gradient-to-bl from-neutral-900 via-neutral-900 to-black" }
const _hoisted_3 = { class: "relative bg-black p-8 lg:py-32" }
const _hoisted_4 = { class: "flex flex-col w-full max-w-lg mx-auto" }
const _hoisted_5 = { class: "mb-8 lg:mb-16 self-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Claim your Dripversity NFT", -1)

import { ref } from "vue";
import MintSteps from "@/views/mint/src/MintSteps.vue";
import MintPreview from "@/views/mint/src/MintPreview.vue";
import AppButtonBackOrHome from "@/components/app/AppButtonBackOrHome.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MintView',
  setup(__props) {

const tokens = ref([]);
const preview = ref<typeof MintPreview>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MintPreview, {
        ref_key: "preview",
        ref: preview,
        image: tokens.value[0]?.metadata?.image,
        alt: tokens.value[0]?.metadata?.name
      }, null, 8, ["image", "alt"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppButtonBackOrHome)
        ]),
        _hoisted_6,
        _createVNode(MintSteps, {
          modelValue: tokens.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((tokens).value = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (preview.value?.pause()))
          ],
          onLoad: _cache[2] || (_cache[2] = ($event: any) => (preview.value?.play()))
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})